import ScrollArea from 'react-scrollbar';
import './scrollbararea.css';

class ScrollbarArea extends ScrollArea {

}

export default ScrollbarArea;


// WEBPACK FOOTER //
// ./src/components/scrollbararea/scrollbararea.js